import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';

/**
 * Used by a Trimble Maps Partner to get a list of their accounts
 * @param params Paged Collection Params
 * @returns An array of company accounts under a Trimble Maps Partner
 */
export function getCompanyList(this: unknown, params?: PagedCollectionParams) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).companyListUrl}${
          params ? `?${params.urlParams}` : ''
        }`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      createPagedCollectionSchema(
        z.object({
          name: z.string().min(1),
          alias: z.string(),
        })
      )
    )
  );
}
